import { Email } from "@mui/icons-material";
import { Button, Tooltip } from "@mui/material";
import { RegistrationStatus } from "../User";

export const registrationEmailButton = (
  status: string,
  emailSaved: boolean,
  handleRegister: () => void,
  handleResend: () => void,
  disabled?: boolean
) => {
  switch (status) {
    case RegistrationStatus.CONFIRMED:
      return;
    case RegistrationStatus.FORCE_CHANGE_PASSWORD:
      return (
        <Button
          type="button"
          className="blue-link-button"
          disabled={!emailSaved || disabled === true}
          onClick={handleResend}
        >
          <Email />
          Re-Send Registration Email
        </Button>
      );
    default:
      const button = (
        <Button
          type="button"
          className="blue-link-button"
          disabled={!emailSaved || disabled === true}
          onClick={handleRegister}
        >
          <Email />
          Send Registration Email
        </Button>
      );
      return !emailSaved ? (
        <Tooltip title="Mariner's email must be filled out before sending registration email">
          <span>{button}</span>
        </Tooltip>
      ) : (
        button
      );
  }
};
